export default "__VITE_ASSET__D3EaGxdx__"